import React from 'react';
import { Flex } from '@marvelapp/ui';
export default function NavigationGridModal(_a) {
    var children = _a.children;
    return (React.createElement(Flex, { bg: 'white', flexDirection: "column", height: "100vh", left: 0, position: "fixed", top: 0, width: 1, zIndex: 1 }, children));
}
